import { ComponentProps, ReactElement, ReactNode, forwardRef } from 'react';

import { ListItemIcon, MenuItem, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  icon: {
    minWidth: '36px',
  },
});

export type MenuOptionProps = Pick<
  ComponentProps<typeof MenuItem>,
  'autoFocus' | 'tabIndex'
> & {
  onClick?: () => void;
  label: string;
  key: string;
  icon?: ReactNode;
  disabled?: boolean;
  selected?: boolean;
  wrapper?: (menuItem: ReactElement) => ReactElement;
};

export const MenuOption = forwardRef<HTMLLIElement, MenuOptionProps>(
  (
    {
      wrapper = node => node,
      onClick,
      disabled: disabledProps,
      label: optionLabel,
      icon,
      selected,
      ...menuItemProps
    },
    ref,
  ) => {
    const classes = useStyles();
    const disabled = !!disabledProps;
    return wrapper(
      <MenuItem
        {...menuItemProps}
        ref={ref}
        disabled={disabled}
        onClick={disabled ? undefined : onClick}
        selected={selected}
        data-track-id={`menuitem.${optionLabel.toLowerCase().replace(/\s+/g, '-')}`}
        data-track-action="update"
      >
        {icon && <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>}
        {optionLabel}
      </MenuItem>,
    );
  },
);
MenuOption.displayName = 'MenuOption';
